export const BANK_LIST = [
  {
    code: "BMRI",
    name: "Bank Mandiri",
    logo: "logo-mandiri.png"
  },
  {
    code: "IBBK",
    name: "Bank Maybank Indonesia",
    logo: "logo-maybank.png"
  },
  {
    code: "BBBA",
    name: "Bank Permata",
    logo: "logo-permata.png"
  },
  {
    code: "BBBB",
    name: "Bank Permata Syariah",
    logo: "logo-permata-syariah.png"
  },
  {
    code: "BNIN",
    name: "Bank Negara Indonesia",
    logo: "logo-bni.png"
  },
  {
    code: "HNBN",
    name: "Bank KEB Hana Indonesia",
    logo: "logo-keb-hana.png"
  },
  {
    code: "BRIN",
    name: "Bank Rakyat Indonesia",
    logo: "logo-bri.png"
  },
  {
    code: "BNIA",
    name: "Bank CIMB Niaga",
    logo: "logo-cimb.png"
  },
  {
    code: "BDIN",
    name: "Bank Danamon Indonesia",
    logo: "logo-danamon.png"
  },
  {
    code: "PDJB",
    name: "Bank BJB",
    logo: "logo-bjb.png"
  }
]